import { lazy } from 'react'
import LoginLoader from './login/loader'
import RegisterLoader from './register/loader'
import RegisterWithXeroLoader from './register/register-with-xero/loader'
import ForgotPasswordLoader from './forgot-password/loader'
import ResetPasswordLoader from './reset-password/loader'
import InvitedToCompanyLoader from './invited-to-company/loader'

export default {
  Login: {
    Component: lazy(() => import('./login/Login.Page')),
    Loader: LoginLoader,
  },
  Register: {
    Component: lazy(() => import('./register/Register.Page')),
    Loader: RegisterLoader,
  },
  SignUpXero: {
    Component: lazy(
      () => import('./register/register-with-xero/RegisterWithXero.Page')
    ),
    Loader: () => RegisterWithXeroLoader,
  },
  ForgotPassword: {
    Component: lazy(() => import('./forgot-password/ForgotPassword.Page')),
    Loader: ForgotPasswordLoader,
  },
  ResetPassword: {
    Component: lazy(() => import('./reset-password/ResetPassword.Page')),
    Loader: ResetPasswordLoader,
  },
  InvitedToCompany: {
    Component: lazy(() => import('./invited-to-company/InvitedToCompany.Page')),
    Loader: () => InvitedToCompanyLoader,
  },
}
